// src/components/analyze/FullHeightInput.jsx

import React, { useRef, useEffect } from 'react';
import { Type } from 'lucide-react';

export default function FullHeightInput({
  value,
  onChange,
  placeholder,
  autoFocus = false,
}) {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (autoFocus && textareaRef.current) {
      setTimeout(() => textareaRef.current?.focus(), 300);
    }
  }, [autoFocus]);

  return (
    /*
      Bukan full-screen, melainkan kartu putih dengan tinggi yang proporsional
      di dalam mobile shell. Mirip dengan kartu input di referensi gamified.
    */
    <div className="px-4 pt-4">
      <div className="bg-white dark:bg-slate-800 rounded-3xl shadow-soft border border-stone-100 dark:border-slate-700 overflow-hidden">

        {/* ── Header Kartu ───────────────────────────── */}
        <div className="flex items-center gap-3 px-4 pt-4 pb-3 border-b border-stone-100 dark:border-slate-700">
          <div className="w-9 h-9 rounded-2xl bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-sm">
            <Type className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <div>
            <p className="text-sm font-extrabold text-slate-800 dark:text-slate-100">
              Masukkan Teks Arab
            </p>
            <p className="text-[10px] text-slate-400 dark:text-slate-500">
              Ketik atau tempel teks Arab di sini
            </p>
          </div>
          {/* Jumlah Karakter */}
          {value?.length > 0 && (
            <div className="ml-auto">
              <span className="text-[10px] font-bold text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800/40 px-2.5 py-1 rounded-full">
                {value.length} kar
              </span>
            </div>
          )}
        </div>

        {/* ── Textarea Arab ──────────────────────────── */}
        <div className="relative">
          <textarea
            ref={textareaRef}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder || 'أدخل النص العربي هنا...'}
            dir="rtl"
            className="
              w-full px-5 py-4
              bg-transparent
              text-right
              text-slate-800 dark:text-slate-100
              placeholder:text-stone-300 dark:placeholder:text-slate-600
              resize-none focus:outline-none
              min-h-[240px]
            "
            style={{
              fontFamily: 'Amiri, Noto Naskh Arabic, serif',
              fontSize: '22px',
              lineHeight: '2.2',
            }}
          />

          {/* Placeholder Ikon saat kosong */}
          {!value && (
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none opacity-30">
              <Type className="w-12 h-12 text-stone-300 dark:text-slate-600 mb-2" />
              <p className="text-xs text-stone-400 dark:text-slate-600 font-medium">
                Ketik atau tempel teks Arab di sini
              </p>
            </div>
          )}
        </div>

        {/* ── Footer Info ────────────────────────────── */}
        {value?.length > 0 && (
          <div className="px-4 pb-3 flex items-center justify-between">
            <p className="text-[10px] text-stone-400 dark:text-slate-500">
              ~{value.split(/\s+/).filter(Boolean).length} kata
            </p>
            <p className="text-[10px] text-stone-400 dark:text-slate-500">
              💡 Teks berharakat = hasil lebih akurat
            </p>
          </div>
        )}

      </div>
    </div>
  );
}